import React from 'react';
import { pureRender } from 'epic-alt-utils';
import autobind from 'core-decorators/lib/autobind';
import map from 'lodash/map';
import { NavActions } from '../../actions';
import { getDataAttribute } from '../../utils/compatibilityUtils';
import { UserIcon } from '../';
import './signIn.sass';

@pureRender
export default class SignIn extends React.Component {

    @autobind
    onClick(e) {
        const index = getDataAttribute(e.currentTarget, 'index');
        const signInLink = this.props.signInLinks[index];
        if (signInLink && signInLink.onClick && typeof signInLink.onClick === 'function') {
            signInLink.onClick(e);
        }

        NavActions.closeMobileTablet.defer();
    }

    @autobind
    close() {
        NavActions.mobileUserActive(false);
        NavActions.mobileNavActiveLinks(true);
    }

    render() {
        if (!this.props.signInLinks) {
            return <div/>;
        }

        const signInLinks = this.props.signInLinks.asMutable ? this.props.signInLinks.asMutable() : this.props.signInLinks || [];
        const dropdown = signInLinks.length > 1;
        const messages = this.context.messages || {};
        const isMobile = this.context.isMobile || false;

        const ulClasses = `bg-color ${this.context.isMobile ? 'mobile-list' : ''} ${this.props.hideCallToAction ? 'ul-right' : 'ul-left'}`;

        return (
            <div
                id="user"
                onClick={this.showSignIn}
                className={`sign-in accent-bg-color-before bg-color ${this.props.isActive && isMobile ? 'active' : ''} ${dropdown ? 'dropdown' : ''}`}>

                {!isMobile ?
                    <UserIcon
                        isLoggedIn={false}
                        mobileUserActive={this.props.isActive}
                        signInLinks={this.props.signInLinks} /> : ''}

                <ul className={ulClasses}>
                {isMobile ?
                    <li
                        className="mobile-heading"
                        onClick={this.close}>
                        <a><span>{messages.sign_in}</span></a>
                    </li> : ''}
                {
                    map(signInLinks, (signInLink, i) => {
                        if (signInLink) {
                            return (
                                <li key={`sign-in-${signInLink.title}`} className={`${this.context.isMobile ? 'mobile-list-item' : ''}`}>
                                    <a
                                        href={signInLink.href || '#'}
                                        data-index={i}
                                        onClick={this.onClick}
                                        title={dropdown ? signInLink.title : messages.sign_in}
                                        className="text-color-hover text-color-nonactive">
                                        <i className="eg-header-icon-user"></i>
                                        <span className="sign-text item-label">{dropdown ? signInLink.title : ''}</span>
                                    </a>
                                </li>
                            );
                        }
                        return undefined;
                    })
                }
                </ul>

            </div>
        );
    }
}

SignIn.propTypes = {
    isActive: React.PropTypes.bool,
    signInLinks: React.PropTypes.array,
    hideCallToAction: React.PropTypes.bool
};

SignIn.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/signIn/SignIn.js
 **/